// These methods still require connection with the state management, but
// there is no alternative for using them at the moment, so the package still
// remains coupled to state management. Once there is an alternative, rewrite
// these methods

import * as stateManagement from '#packages/stateManagement';
import constants from '#packages/constants';

import type { EditorAPI } from '#packages/editorAPI';
import type { CompRef } from 'types/documentServices';

export const getEssentialData = (editorAPI: EditorAPI, compRef: CompRef) => {
  const { platform } = stateManagement;
  if (!compRef) {
    return;
  }

  const { isEssential, text: essentialText } =
    platform.selectors.getEssentialData(editorAPI, compRef);

  return { isEssential, essentialText };
};

export const openLayersPanel = (editorAPI: EditorAPI) => {
  editorAPI.store.dispatch(
    stateManagement.layersPanel.actions.showLayersPanel('hidden items panel'),
  );
};

export const locateComponentAndHighlight = (
  editorAPI: EditorAPI,
  compRef: CompRef,
) => {
  editorAPI.store.dispatch(
    stateManagement.componentLocator.actions.locateComponentAndHighlight(
      compRef,
      true,
      constants.UI.HIGHLIGHTS.TYPES.NORMAL_WITH_OVERLAY,
    ),
  );
};

export const clearHighlights = (editorAPI: EditorAPI) => {
  editorAPI.store.dispatch(
    stateManagement.highlights.actions.clearHighlights(),
  );
};

export const openInlinePopupIfFocused = (editorAPI: EditorAPI) => {
  const state = editorAPI.store.getState();
  const { selection, inlinePopup } = stateManagement;

  const focusedContainer = selection.selectors.getFocusedContainer(state);
  if (editorAPI.components.is.inlinePopup(focusedContainer)) {
    editorAPI.store.dispatch(inlinePopup.actions.open(focusedContainer));
  }
};
